import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuthLogout } from "./index"

export const bankMappingApi = createApi({
    reducerPath: "bankMappingApi",
    baseQuery: baseQueryWithAuthLogout,
    tagTypes: ["BankMapping"],
    endpoints: (builder) => ({
        getBankMappingData: builder.query({
            query: ({ page = 1, limit = 25, search = "" }) => `/payee-account?page=${page}&limit=${limit}&search=${search}`,
            providesTags: ["BankMapping"],
        }),

        saveBankMapping: builder.mutation({
            query: (payload) => ({
                url: `/payee-account`,
                method: "POST",
                body: payload,
            }),
            invalidatesTags: ["BankMapping"],
        }),
        updateBankMapping: builder.mutation({
            query: ({ id, data }) => ({
                url: `/payee-account/${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["BankMapping"],
        }),

        deleteBankMapping: builder.mutation({
            query: (id) => ({
                url: `/payee-account/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["BankMapping"],
        }),
    }),
});

export const {
    useGetBankMappingDataQuery,
    useSaveBankMappingMutation,
    useUpdateBankMappingMutation,
    useDeleteBankMappingMutation
} = bankMappingApi;
